import { ref as o, onMounted as d, onBeforeMount as a, onBeforeUnmount as u } from "vue";
function l() {
  const n = o(!1), i = o(!1), t = o(!1);
  function r(s) {
    const e = s.currentTarget;
    n.value = e.innerWidth < 1200, i.value = e.innerWidth < 1024 && e.innerWidth >= 769, t.value = e.innerWidth < 769;
  }
  return d(() => {
    n.value = window.innerWidth < 1200, i.value = window.innerWidth < 1024 && window.innerWidth >= 769, t.value = window.innerWidth < 769;
  }), a(() => {
    window.addEventListener("resize", r);
  }), u(() => {
    window.removeEventListener("resize", r);
  }), { isTablet: i, isMobile: t, isDesktop: n };
}
export {
  l as useBreakpoints
};
